import React from 'react';

const MarqueeNotice = () => {
  return (
    <div className="w-full h-7 2xl:h-10 bg-[#122e5a] text-white text-[11px] lg:text-[13px] flex items-center border-t-2 border-[#1a3b6e]">
      <div className="text-yellow-400 font-extrabold px-2 shrink-0 uppercase tracking-wider">
        NOTICE
      </div>
      <div className="flex-1 overflow-hidden flex items-center h-full border-l border-white/20 pl-3">
        <marquee scrollamount="4" className="font-semibold text-white/90 leading-none pt-0.5">
          Please take backup to External Medias regularly. For support: 7560889991 / 7560889970 / 7560880900 / 7560888930. &nbsp;&nbsp;|&nbsp;&nbsp; ⚠️ SherSoft has no responsibility for data loss without backup. &nbsp;&nbsp;|&nbsp;&nbsp; 📞 Contact: shersoftware@gmail.com &nbsp;&nbsp;|&nbsp;&nbsp; 🌐 www.shersoftware.com
        </marquee>
      </div>
    </div>
  );
};

export default MarqueeNotice;
